<template>
    <v-card class="elevation-12" style="width:100%">
    <!-- <v-toolbar
      color="primary"
      dark
      height="35"
    >
    </v-toolbar> -->
    <v-card-text style="height:100%;">
      <div v-if="loading" style="height:100%; width:100%; text-align: center;">
        <v-icon  x-large style="height:100%; font-size:150px;   margin: 0 auto;">mdi-chart-pie</v-icon>
      </div>
      <div v-else-if="transactions.length > 0">
<h3 class="pl-5 pt-1" >Потребление топлива</h3>
      <h6 class="pl-5 text--disabled">В литрах по каждой марке топлива</h6>
      <div style="width:100%;height:100%;">
        <div>
        <v-row align="center" justify="center" v-if="transactions.length > 0">
          <bar-chart :chart-data="dataChart" :options="dataOptions" style="height: auto; width: 75%; max-height: 300px;"></bar-chart>
          <!-- <canvas v-show="!loading" ref="canvas" width="auto"></canvas> -->
        </v-row>

          <br>
          <br>
          <v-simple-table fixed-header height="auto" >
            <thead>
              <th class="text-center">Марка топлива</th>
              <th class="text-center">Количество</th>
            </thead>
        <!-- <p class="text--secondary">По каждому виду топлива</p> -->
        <tbody v-if="marks">
            <tr  v-for="item in marks" :key="item.serviceType">
            <td class="text-center">{{ item }}</td>
            <td class="text-center">{{ GetMarkValueSum(item).toFixed(2) }} л.</td>
            </tr>
        </tbody>
        </v-simple-table>
        </div>
          <v-row align="center" justify="center" v-if="loading">
          <h4 class="center text-center">нет данных</h4>
        </v-row>
          <br>
          <h3 class="pl-5 pt-1" >Дневное потребление топлива</h3>
          <h6 class="pl-5 text--disabled">Среднее в литрах по каждой марке топлива</h6>
          <br>
          <v-simple-table fixed-header height="auto" >
            <thead>
              <th class="text-center">Марка топлива</th>
              <th class="text-center">Количество</th>
            </thead>
        <!-- <p class="text--secondary">По каждому виду топлива</p> -->
        <tbody v-if="marks">
            <tr  v-for="item in marks" :key="item.serviceType">
            <td class="text-center">{{ item }}</td>
            <td class="text-center">{{ (getRateValueSum(item) / getUnquieDate().length).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '$& ')}} л.</td>
            </tr>
        </tbody>
        </v-simple-table>
      </div>
      </div>
      <div v-else style="height:100%; width:100%; text-align: center;">
        <v-row align="center" class="fill-height" justify="center" >
          <v-col>
            <h5>Нет данных</h5>
            <span class="text-subtitle-1">За выбранный период отсутсвутют данные. Проверьте токен данной системы ТК (для ППР) или <router-link to="uploadReport">загрузите отчет</router-link> за выбранный период</span>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import BarChart from './PieChart.js'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      dataChart: {},
      dataOptions: {
        maintainAspectRatio: false,
        barValueSpacing: 1,
        legend: {
          display: true,
          position: 'bottom',
          align: 'center',
          fullWidth: true,
          labels: {
            fontColor: '#007bff'
          }
        }
      }
    }
  },
  components: {
    BarChart
  },
  computed: {
    ...mapState({
      transactions: state => state.transactions.transactions,
      marks: state => state.transactions.marks,
      loading: state => state.transactions.transactionsLoading
    })
  },
  watch: {
    marks: function () {
      this.DrawChart()
    }
  },
  mounted () {
    this.DrawChart()
  },
  methods: {
    GetMarkValueSum (item) {
      return this.transactions.reduce((total, t) => {
        // eslint-disable-next-line eqeqeq
        if (item != 'Инф.усл.') {
          // eslint-disable-next-line eqeqeq
          if (t.serviceType == item) {
            total += t.value
          }
        }
        return total
      }, 0)
    },
    getUnquieDate () {
      if (this.transactions) {
        return [...new Set(
          this.transactions.map((str) => str.transactionDate.match(/^\d{4}-\d{2}-\d{2}/)[0])
        )]
      }
    },
    getRateValueSum (item) {
      return this.transactions.reduce((total, t) => {
        // eslint-disable-next-line eqeqeq
        if (item != 'Инф.усл.') {
          // eslint-disable-next-line eqeqeq
          if (t.serviceType == item) {
            total += t.value
          }
        }
        return total
      }, 0)
    },
    DrawChart () {
      if (this.transactions && this.marks) {
        this.dataChart = {
          labels: this.marks,
          datasets: [{
            data: this.marks.map(m => {
            // eslint-disable-next-line eqeqeq
              if (m != 'Инф.усл.') {
                return this.transactions.reduce((total, t) => {
                  // eslint-disable-next-line eqeqeq
                  if (t.serviceType == m) {
                    total += t.value
                  }
                  return total
                }, 0)
              }
            }),
            backgroundColor: [
              'rgba(62, 209, 158, 1)',
              'rgba(38, 104, 248, 1)',
              'rgba(119, 88, 148, 1)',
              'rgba(227, 208, 21, 1)',
              'rgba(168, 17, 13, 1)',
              'rgba(39, 83, 93, 1)'
            ],
            borderColor: 'cyan',
            borderWidth: 0
          }]
        }
      }
    }
  }
}
</script>
